var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"bg-light"},[_c('b-row',{staticClass:"row text-white bg-kpmg-dark-blue py-4 mb-4"},[_c('b-col',{staticClass:"col"},[_c('h1',{staticClass:"kstyle"},[_vm._v("adding ESG subscription")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }